var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18164 4.18164C6.55273 3.81055 6.99219 3.625 7.5 3.625C8.00781 3.625 8.44727 3.81055 8.81836 4.18164C9.18945 4.55273 9.375 4.99219 9.375 5.5C9.375 6.00781 9.18945 6.44727 8.81836 6.81836C8.44727 7.18945 8.00781 7.375 7.5 7.375C6.99219 7.375 6.55273 7.18945 6.18164 6.81836C5.81055 6.44727 5.625 6.00781 5.625 5.5C5.625 4.99219 5.81055 4.55273 6.18164 4.18164ZM5.27344 7.72656C5.89844 8.33203 6.64062 8.63477 7.5 8.63477C8.35938 8.63477 9.0918 8.33203 9.69727 7.72656C10.3223 7.10156 10.6348 6.35938 10.6348 5.5C10.6348 4.64062 10.3223 3.9082 9.69727 3.30273C9.0918 2.67773 8.35938 2.36523 7.5 2.36523C6.64062 2.36523 5.89844 2.67773 5.27344 3.30273C4.66797 3.9082 4.36523 4.64062 4.36523 5.5C4.36523 6.35938 4.66797 7.10156 5.27344 7.72656ZM3.31055 2.10156C4.56055 1.24219 5.95703 0.8125 7.5 0.8125C9.04297 0.8125 10.4395 1.24219 11.6895 2.10156C12.9395 2.96094 13.8379 4.09375 14.3848 5.5C13.8379 6.90625 12.9395 8.03906 11.6895 8.89844C10.4395 9.75781 9.04297 10.1875 7.5 10.1875C5.95703 10.1875 4.56055 9.75781 3.31055 8.89844C2.06055 8.03906 1.16211 6.90625 0.615234 5.5C1.16211 4.09375 2.06055 2.96094 3.31055 2.10156Z",
    fill: "#555D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ca13123f22eeb1905dd41a085f778392.svg";
export { ForwardRef as ReactComponent };